import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

// Public-page "are you sure?" gate for self-unregistration. Extracted
// from TournamentPublicPage. Submitting-aware so the open-state
// callback doesn't let the user dismiss while the request is in flight.

interface Props {
  open: boolean;
  submitting: boolean;
  tournamentName: string;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function UnregisterConfirmDialog({
  open,
  submitting,
  tournamentName,
  onOpenChange,
  onConfirm,
}: Props) {
  const { t } = useTranslation('tournament');

  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!submitting) onOpenChange(next);
      }}
    >
      <DialogContent data-testid="unregister-confirm-dialog">
        <DialogHeader>
          <DialogTitle>
            {t('public_page.unregister_dialog.title', { name: tournamentName })}
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          {t('public_page.unregister_dialog.body')}
        </p>
        <DialogFooter>
          <Button
            variant="outline"
            data-testid="unregister-cancel-button"
            onClick={() => onOpenChange(false)}
            disabled={submitting}
          >
            {t('public_page.buttons.cancel')}
          </Button>
          <Button
            variant="destructive"
            data-testid="unregister-confirm-button"
            onClick={onConfirm}
            disabled={submitting}
          >
            {submitting
              ? t('public_page.buttons.unregistering')
              : t('public_page.buttons.unregister')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
